export default {
  init() {

    // JavaScript to be fired on the home page
    if($('.home-slider').length) {

        if (!$('html.svgasimg').length) {
          $("img[src$='.svg']")
            .attr("src", 'jpg');
        }

        $('.home-slider').slick({
            dots: false,
            infinite: true,
            fade: true,
            cssEase: 'linear',
            speed: 300,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
        });
    }

    // manualy disabling scroll effects
    let nkActiveScrollEffects = false;
    if($(".no-touchevents.scroll-transitions-active").length && nkActiveScrollEffects == true) {

        /* eslint-disable */
        var controller = new ScrollMagic.Controller();

        // Scroll durations
        var offsetWindowHeight = $(window).height();
        var offsetHalfWindowHeight = $(window).height() / 2;

     //    //TEXT TRANSITIONS

        if (!$.browser.mozilla) {
            // NOT GREAT BUT A BETTER EXPERIENCE

            var textEl = ".desktop .home__blocks__block__text";
            var duration;
            var textElCount = 1;
            var offsetCondition;
            $(textEl).each(function (index) {
                textElCount = textEl+"__"+index;
                var currentScreenInner = textElCount;
                var currentScreenInnerText = textElCount + ' .home__blocks__block__text__inner';
                var textMove = TweenMax.fromTo(currentScreenInnerText, 0.2,
                    {y: -300},
                    {y: 300, ease:Linear.easeNone, autoRound:true, force3D:true}
                );
                new ScrollMagic.Scene({
                    triggerElement: currentScreenInner,
                    duration: "180%",
                    triggerHook: "onEnter",
                })
                .setTween(textMove)
                .addTo(controller);

                if($(this).hasClass("home__blocks__block__text__black")) {
                    new ScrollMagic.Scene({duration: offsetWindowHeight, triggerElement: this})
                    .setClassToggle("body", "scroll-transitions-black") // add class toggle
                    .addTo(controller);
                }
         //       .addIndicators({zindex: 1, suffix: currentScreenInner});
            });

        }


        //IMAGE TRANSITIONS
        var imgEl = ".desktop .home__blocks__block__image";
        var imgElCount = 1;
        //console.log(imgEl);
        $(imgEl).each(function (index) {
            imgElCount = imgEl+"__"+index;
            var currentImgEl = imgElCount + ' .home__blocks__block__image__inner';
            var imgBackgroundMove = TweenMax.fromTo(currentImgEl, 0.2,
             {y: '-300px'},
             {y: '300', ease:Linear.easeNone, autoRound:true, force3D:true}
            );

            new ScrollMagic.Scene({
                triggerElement: currentImgEl,
                duration: "200%",
                triggerHook: "onEnter"
            })
            .setTween(imgBackgroundMove)
            .addTo(controller);
//          .addIndicators({zindex: 1, suffix: currentImgEl});

        });


        // OTHER SECTIONS
        var sectionEl = ".desktop .scroll-section";
        var sectionElCount = 1;
        $(sectionEl).each(function (index) {
            sectionElCount = sectionEl+"__"+index;
            var sectionCurrentScreen = this;
            var sectionCurrentScreenInner = sectionElCount + ' .section__wrapper';
            var tween = TweenMax.fromTo(sectionCurrentScreenInner, 0.2, {css: {opacity: 0, 'transform': 'translateY(-200px)'}}, {css:{opacity: 1, 'transform': 'translateY(0)'}}, {force3D:true});
            new ScrollMagic.Scene({
                triggerElement: sectionCurrentScreen,
                duration: '100%',
                offset: -offsetHalfWindowHeight
            })
            .setTween(tween)
            .addTo(controller);
            //.addIndicators({zindex: 1, suffix: 'pin'});
        })

    }
    /* eslint-enable */


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

  }
};
